import React from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { formatPoints } from "./formatPoints";

const TablePointsExpiration = ({ myPoints, program }) => {
  const { t } = useTranslation();
  const rows = myPoints?.expiration ? Object.values(myPoints.expiration) : [];

  if (rows.length === 0) return null;

  const fmt = (ts) =>
    new Date(ts.replace(' ', 'T')).toLocaleDateString('en-US', {
      month: 'long', day: 'numeric', year: 'numeric',
    });

  return (
    <div className="mp-table-wrap">
      <h2 className="mp-table-wrap__title">{t('points_expirations')}</h2>
      <table className="mp-table mp-table--expiration">
        <thead>
          <tr>
            <th>{t('date')}</th>
            <th className="mp-table__num">{t('points')}</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i}>
              <td data-label={t('date')}>{t('points_expiring')} {fmt(row.expiration)}</td>
              <td className="mp-table__num mp-table__pts--neg" data-label={t('points')}>
                {formatPoints(row.amount * program.factor_valuation)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const mapStateToProps = (state) => ({
  myPoints: state.participant.myPoints,
  program:  state.program,
});

export default connect(mapStateToProps)(TablePointsExpiration);
